import api from '../index'

let header = {}

export default {
    // 校验验证码
    checkCode(params) {
        return api.post(`/serve/sms/verify`, params, header)
    },
    // 发送验证码（旧）
    sendCode(params){
        return api.get(`/common/sms/${params.phoneNumber}`, {}, header)
    },
    // 发送验证码（新）
    sendNewCode(params) {
        return api.get(`/common/newSms/${params.phoneNumber}`, params, header)
    },
    //门户重置密码
    resetPwd(params){
        // return api.post(`/user/own/resetPwd`, params, header)
        return api.post('/user/forgotPwd', params, header)
    },
    //登录界面重置密码
    forgotPwd(params){
        return api.post(`/user/forgotPwd`, params, header)
    },
    // 获取用户可登陆企业
    getEnterpriseByUser(params) {
        return api.get(`/user/enterprise`, params, header)
    },
    // 切换阻止
    changeEnterprise(params) {
        return api.post('/oauth/changeEnt', params, header)
    }
}
